import { lazy } from 'react';
import { FaultsDashboardsProvider, PDFContextProvider, VisitDashboardProvider } from '../../contexts';
import { SidebarLayout } from '../../layouts';
import { PermissionsGuard } from './Components';
import { Loader } from './loader.routes';

const ClientDashboard = Loader(lazy(() => import('../../content/pages/Dashboards/ClientDashboard')));
const FaultsDashboard = Loader(lazy(() => import('../../content/pages/Dashboards/FaultsDashboard')));
const ProCleanDashboard = Loader(lazy(() => import('../../content/pages/Dashboards/ProCleanDashboard')));
const ProCleanPlusDashboard = Loader(lazy(() => import('../../content/pages/Dashboards/ProCleanPLUSDashboard')));
const Sos1Dashboard = Loader(lazy(() => import('../../content/pages/Dashboards/SOS1Dashboard')));

const Sos2Dashboard = Loader(lazy(() => import('../../content/pages/Dashboards/SOS2Dashboard')));
const Sos3Dashboard = Loader(lazy(() => import('../../content/pages/Dashboards/SOS3Dashboard')));
const WinterisationDashboard = Loader(lazy(() => import('../../content/pages/Dashboards/WinterisationDashboard')));

const DewinterisationDashboard = Loader(lazy(() => import('../../content/pages/Dashboards/DewinterisationDashboard')));
const ChillPourDashboard = Loader(lazy(() => import('../../content/pages/Dashboards/ChillPourDashboard')));
const CellarPlusDashboard = Loader(lazy(() => import('../../content/pages/Dashboards/CellarPLUSDashboard')));
//const ProSpecDashboard = Loader(lazy(() => import('../../content/pages/Dashboards/ProSpecDashboard')));
// const ProCleanPlusDashboardPDF = Loader(
//   lazy(() => import('../../content/pages/Dashboards/PDFReports/ProCleanPLUSDashboardPDF'))
// );

export const createDashboardRoutes = (groupRequired?: null | string, roleRequired?: null | string[]) => ({
  path: 'dashboard',
  element: <SidebarLayout />,
  children: [
    {
      path: 'proclean-plus/:visitId',
      element: (
        <PermissionsGuard allowedPermissions={['visitDashboardView']} should404>
          <VisitDashboardProvider>
            <PDFContextProvider>
              <ProCleanPlusDashboard />
            </PDFContextProvider>
          </VisitDashboardProvider>
        </PermissionsGuard>
      )
    },
    // {
    //   path: 'proclean-plus/:visitId/pdf',
    //   element: (
    //     <PermissionsGuard allowedPermissions={['visitDashboardView']} should404>
    //       <VisitDashboardProvider>
    //         <PDFContextProvider>
    //           <ProCleanPlusDashboardPDF />
    //         </PDFContextProvider>
    //       </VisitDashboardProvider>
    //     </PermissionsGuard>
    //   )
    // },
    {
      path: 'proclean/:visitId',
      element: (
        <PermissionsGuard allowedPermissions={['visitDashboardView']} should404>
          <VisitDashboardProvider>
            <PDFContextProvider>
              <ProCleanDashboard />
            </PDFContextProvider>
          </VisitDashboardProvider>
        </PermissionsGuard>
      )
    },
    {
      path: 'client',
      element: (
        <PermissionsGuard allowedPermissions={['clientDashboardView']} should404>
          <ClientDashboard />
        </PermissionsGuard>
      )
    },
    {
      path: 'faults/:visitFaultId',
      element: (
        <PermissionsGuard allowedPermissions={['visitDashboardView']} should404>
          <FaultsDashboardsProvider>
            <FaultsDashboard />
          </FaultsDashboardsProvider>
        </PermissionsGuard>
      )
    },
    {
      path: 'sos-lv1/:visitId',
      element: (
        <PermissionsGuard allowedPermissions={['visitDashboardView']} should404>
          <VisitDashboardProvider>
            <PDFContextProvider>
              <Sos1Dashboard />
            </PDFContextProvider>
          </VisitDashboardProvider>
        </PermissionsGuard>
      )
    },
    {
      path: 'sos-lv2/:visitId',
      element: (
        <PermissionsGuard allowedPermissions={['visitDashboardView']} should404>
          <VisitDashboardProvider>
            <PDFContextProvider>
              <Sos2Dashboard />
            </PDFContextProvider>
          </VisitDashboardProvider>
        </PermissionsGuard>
      )
    },
    {
      path: 'sos-lv3/:visitId',
      element: (
        <PermissionsGuard allowedPermissions={['visitDashboardView']} should404>
          <VisitDashboardProvider>
            <PDFContextProvider>
              <Sos3Dashboard />
            </PDFContextProvider>
          </VisitDashboardProvider>
        </PermissionsGuard>
      )
    },
    {
      path: 'winterization/:visitId',
      element: (
        <PermissionsGuard allowedPermissions={['visitDashboardView']} should404>
          <VisitDashboardProvider>
            <PDFContextProvider>
              <WinterisationDashboard />
            </PDFContextProvider>
          </VisitDashboardProvider>
        </PermissionsGuard>
      )
    },
    {
      path: 'dewinterization/:visitId',
      element: (
        <PermissionsGuard allowedPermissions={['visitDashboardView']} should404>
          <VisitDashboardProvider>
            <PDFContextProvider>
              <DewinterisationDashboard />
            </PDFContextProvider>
          </VisitDashboardProvider>
        </PermissionsGuard>
      )
    },
    {
      path: 'chill-pour/:visitId',
      element: (
        <PermissionsGuard allowedPermissions={['visitDashboardView']} should404>
          <VisitDashboardProvider>
            <PDFContextProvider>
              <ChillPourDashboard />
            </PDFContextProvider>
          </VisitDashboardProvider>
        </PermissionsGuard>
      )
    },
    {
      path: 'cellarplus/:visitId',
      element: (
        <PermissionsGuard allowedPermissions={['visitDashboardView']} should404>
          <VisitDashboardProvider>
            <PDFContextProvider>
              <CellarPlusDashboard />
            </PDFContextProvider>
          </VisitDashboardProvider>
        </PermissionsGuard>
      )
    }
    /*{
      path: 'pro-spec',
      element: (
        <ProtectedRoute groupRequired={['avani']} roleRequired={['*']}>
          <ProSpecDashboard />
        </ProtectedRoute>
      )
    }, */
  ]
});
